import { useEffect, useState } from 'react';
import IconSvg from './ui/IconSvg';
import { useAccount } from 'wagmi';
import { useHttp } from 'src/hooks';

const LootyPoints = () => {
  const { address } = useAccount();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { sendRequest } = useHttp();

  const [userPoints, setUserPoints] = useState<number>(0);

  const challenges = [
    {
      id: '1',
      name: 'Connect Wallet',
      points: 20,
    },

    // {
    //   id: '2',
    //   name: 'Connect Discord',
    //   points: 50,
    // },
    // {
    //   id: '3',
    //   name: 'Connect Twitter',
    //   points: 60,
    // },

    // {
    //   id: '4',
    //   name: 'Share reward on twitter',
    //   points: 110,
    // },
    {
      id: '5',
      name: 'Mint key',
      points: 110,
    },
    {
      id: '6',
      name: 'Open box',
      points: 220,
    },
  ];
  const getUserPoints = () => {
    if (address) {
      sendRequest(
        {
          url: `user/total-points/${address}`,
          method: 'GET',
        },
        (data: any) => {
          setUserPoints(data);
        },
      );
    }
  };

  useEffect(() => {
    getUserPoints();
  }, [address]);

  return (
    <>
      {address && (
        <div
          className="relative inline-block text-left cursor-pointer"
          onMouseEnter={() => setIsMenuOpen(true)}
          onMouseLeave={() => setIsMenuOpen(false)}
        >
          <div className="flex items-center space-x-[10px]">
            <IconSvg icon="starM" />
            <div className="font-semibold text-grayscale-200">{userPoints}</div>
          </div>

          {isMenuOpen && (
            <div
              className="absolute right-0 mt-2 w-64 p-5 origin-top-right bg-grayscale-800 rounded-md shadow-lg ring-1 ring-white ring-opacity-5 focus:outline-none z-50"
              onMouseEnter={() => setIsMenuOpen(true)}
              onMouseLeave={() => setIsMenuOpen(false)}
            >
              <div className="flex items-center pb-4 border-b-2 border-gray-700">
                <div className="flex space-x-2 items-center">
                  <p className="text-grayscale-100 font-jetbrains font-normal text-base leading-5">
                    Earn looty points
                  </p>
                </div>
              </div>
              {challenges.map(challenge => (
                <div
                  key={challenge.id}
                  className="group flex w-full items-center justify-between gap-2 py-2 font-jetbrains font-normal text-xs text-gray-300"
                >
                  <div className="flex space-x-2 items-center">
                    <p>{challenge.name}</p>
                  </div>
                  <span className="flex gap-[3.5px] items-center font-jetbrains font-semibold text-xs text-grayscale-200">
                    {`${challenge.points}`}
                    <IconSvg icon="starS" />
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default LootyPoints;
